<template>
    <div>
        <CajitaSuceso :sucesoProp="suceso">
        </CajitaSuceso>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import CajitaSuceso from './CajitaSuceso.vue';
import type { SucesoDetalleModel } from '@/.shared/.api';

const props = defineProps<{ sucesoProp: SucesoDetalleModel }>();
const suceso = computed(() => props.sucesoProp); // cuando cambie props.suceso, coge todos los items de la template donde se use dataSource y los recarga
</script>